// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","primary":"Button_primary__XYgy-","rounded":"Button_rounded__+9j5O","grouped":"Button_grouped__yXg0U","nowrap":"Button_nowrap__mGiHx"};